import axios from 'axios';

const BASE_URL = `${window.__RUNTIME_CONFIG__?.REACT_APP_AUTH_SERVICE}/users`;

const loginUser = async (credentials) =>
  axios.post(`${BASE_URL}/authenticate`, { ...credentials });

const registerUser = async (registerData) =>
  axios.post(`${BASE_URL}/create`, { ...registerData });

const resetPassword = async (email) =>
  axios.get(`${BASE_URL}/reset-password?email=${email}`);

const changePassword = async (passwordData) =>
  axios.post(`${BASE_URL}/change-password`, { ...passwordData });

export { loginUser, registerUser, resetPassword, changePassword };
